import { render } from "./Breadcrumb.vue?vue&type=template&id=e4f9824c"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Navigation/Breadcrumb.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e4f9824c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e4f9824c', __exports__)) {
    api.reload('e4f9824c', __exports__)
  }
  
  module.hot.accept("./Breadcrumb.vue?vue&type=template&id=e4f9824c", () => {
    api.rerender('e4f9824c', render)
  })

}


export default __exports__